import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoDocumentosPlantillaComponent {
  constructor (FanProyectoDocumentosPlantillaService, $location) {
    this.idProyecto = undefined
    this.idPlantilla = undefined
    this.version = undefined
    this.nombrePlantilla = null
    this.FanProyectoDocumentosPlantillaService = FanProyectoDocumentosPlantillaService
    this.seleccionado = null
    this.$location = $location
  }

  $onInit () {
    this.promise = this.FanProyectoDocumentosPlantillaService.get(this.idProyecto, this.idPlantilla)
      .then((response) => {
        this.data = response.data
        this.versiones = response.data.versiones
          .map((item) => ({
            id: Number(item.version),
            descripcion: `Versión ${item.version}`,
          }))
        this.seleccionado = this.data.versiones.find((item) => item.version === this.version)
        this.nombrePlantilla = this.data.nombre
        this.seleccionado.nombre = this.nombrePlantilla
      })
  }

  actualizar (item, data) {
    if (data) {
      this.nombrePlantilla = data.nombre
      delete data.nombre
      if (data.predeterminado) {
        this.data.versiones.forEach((item) => (item.predeterminado = item === data))
      }

      this.data.versiones.splice(this.data.versiones.indexOf(item), 1, data)
      this.seleccionar()
    }
  }

  seleccionar () {
    this.seleccionado = this.data.versiones.find((item) => item.version === this.version)
    this.seleccionado.nombre = this.nombrePlantilla
    this.$location.search({version: this.version})
    this.$location.replace()
  }
}

module.component('fanProyectoDocumentosPlantilla', {
  controller: FanProyectoDocumentosPlantillaComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    idPlantilla: '<',
    version: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/plantilla/component.js